const t={categoryIds:["TE","ET","ED","MO","IN","MD"],limit:6,showAllDepartments:!0};export{t as DEFAULT_TOP_CATEGORIES};
